<div class="container-fluid container-box" [ngClass]="{'codecrosswalk-width': currentTab == tabName.CODECROSSWALK_TAB}">
  <div class="grid-box">
     <app-ag-grid 
       class="center-Pagination d-block position-relative minHeightSet"
       [ngStyle]="{'height': flexHeight}" 
       [dataModel]="dataModel" 
       [paginations]="false"
       [columnSettings]="false"
       [rowData]="rowData"
       (gridReady)="onGridReady($event)" 
       >
    </app-ag-grid>
    <app-custom-loader class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;" [isLoaderLoading]="isLoading"></app-custom-loader>
  </div>
  <div class="wrapper mt-3">
    <div class="footer-box" [style.width.px]="actWidth">
      <app-button *ngIf="currentTab !== tabName.CODECROSSWALK_TAB"
       class="px-1 px-sm-2" [button_2]="true" [buttonClass]="'button button-info mx-0'"
        [buttonLable]="enumButtonName.CANCEL" (click)="closeTab()">
      </app-button>
      <app-button *ngIf="currentTab === tabName.CODECROSSWALK_TAB"
      class="px-1 px-sm-2" [button_2]="true" [buttonClass]="'button button-info mx-0'"
       [buttonLable]="enumButtonName.CANCEL" (click)="close()">
     </app-button>

      <app-button progressStepPrev class="px-1 px-sm-2" [button_2]="true" [buttonClass]="'button dark-info mx-0'"
        [buttonLable]="enumButtonName.PREVIOUS" (click)="backToImport()">
      </app-button>
      <app-button progressStepNext class="ps-1 ps-sm-2" [button_2]="true" [buttonClass]="importDocumentsService.submit?'button button-primary mx-0':'button  dark-info mx-0'"
        [buttonLable]="enumButtonName.NEXT" (click)="handleClick()"> 
      </app-button>
    </div>
  </div>
</div> 